import client from "./axiosConfig";

export const createVendor = (data) => {
    const config = {
        url: `/procurement/vendors/`,
        method: "POST",
        data,
    };
    const response = client(config);
    return response;
};

export const getVendor = (params) => {
    const config = {
        url: `/procurement/vendors/`,
        method: "GET",
        params,
    };
    const response = client(config);
    return response;
};

export const getVendorById = (id) => {
    const config = {
        url: `/procurement/vendors/${id}/`,
        method: "GET",
    };
    const response = client(config);
    return response;
};

export const updateVendor = (id, data) => {
    const config = {
        url: `/procurement/vendors/${id}/`,
        method: "PATCH",
        data,
    };
    const response = client(config);
    return response;
};

export const getVendorProduct = (vendorId,params) => {
    const config = {
        url: `/procurement/vendors/${vendorId}/products/`,
        method: "GET",
        params
    }
    const response = client(config);
    return response;
}

export const addVendorProduct = (vendorId, data) => {
    const config = {
        url: `/procurement/vendors/${vendorId}/products/`,
        method: "POST",
        data
    }

    const response = client(config);
    return response;
}

export const deleteVendorProduct = (vendorId,productId) => {
    const config = {
        url: `/procurement/vendors/${vendorId}/products/${productId}/`,
        method: "DELETE",
    }

    const response = client(config);
    return response;
}

export const deleteVendor = (vendorId) => {
    const config = {
        url: `/procurement/vendors/${vendorId}/`,
        method: "DELETE",
    }

    const response = client(config);
    return response;
}